/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import MuiTableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from './TableSimple.module.css';

const useStyles = makeStyles({
    table: {
        minWidth: 400,
        "& .MuiTableCell-root": {
            borderLeft: "1px solid rgba(224, 224, 224, 1)",

        },

    }
});



const TableSimple = ({ tableColumnData, tableHeaderLabel, TableRowHederAling,size,headerColor }) => {
    const classes = useStyles();
    const tableHeader = tableHeaderLabel.map((lable) => (<TableCell key={lable} align={TableRowHederAling}>{lable}</TableCell>))
    const tableRow = tableColumnData.map((row,id) => {
        return (<TableRow  key={`pratik${id}`} size={size}> 
            {Object.entries(row).map(([lable, value], idx) => ( 
                <TableCell   align={TableRowHederAling}>
                    {value}
                </TableCell>
            ))
            }
        </TableRow>)
    });
    const TableHead = withStyles((theme) => ({
        root: {
            backgroundColor: headerColor
        }
    }))(MuiTableHead);
    return (
        <TableContainer>
            {/* <Table className={classes.table} size={tableRow.length>=2?size:size} aria-label="a dense table"> */}
            <Table className={classes.table} size={size} aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        {tableHeader}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableRow}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

TableSimple.propTypes = {
    tableColumnData: PropTypes.array,
    tableHeaderLabel: PropTypes.array,
    TableRowHederAling: PropTypes.string,
    size: PropTypes.string,
    headerColor: PropTypes.string,


};

export default TableSimple;
